import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  totalRows: 0,
  leaderboardList: [],
};

const leaderboard = createSlice({
  name: "leaderboard",
  initialState,
  reducers: {
    getLeaderboardDataRequest(state) {
      state.loading = true;
    },
    getLeaderboardDataSuccess(state, action) {
      state.leaderboardList = action.payload.userLeaderboardList || [];
      state.totalRows = action.payload.totalRows || 0;
      state.loading = false;
    },
    getLeaderboardDataFailed(state) {
      state.leaderboardList = [];
      state.loading = false;
    },
  },
});
export const leaderboardAction = leaderboard.actions;
export default leaderboard.reducer;
